import { logError, logWarning } from '@databases/logs';
import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseCardWidth, DatabaseLayoutType } from '@databases/types/database/view';

import { SiteService } from '@canvas/atlassian-service/site';

import type { ProcessingError } from './types';

enum ExtendedDatabaseFieldTypeMapping {
  'TAG' = 'SELECT',
  'JIRA-WORK-ITEM' = 'JIRA_ISSUE',
  'CONFLUENCE-PAGE-LINK' = 'PAGE_LINK',
  'CONFLUENCE-PAGE-STATUS' = 'PAGE_STATUS',
  'CONFLUENCE-PAGE-LABEL' = 'PAGE_LABELS',
}

export const stringToDatabaseFieldType = (str: string): DatabaseFieldType | undefined => {
  // in order to be more robust, we will convert alternative names for a field types
  if (str.toUpperCase() in ExtendedDatabaseFieldTypeMapping) {
    return DatabaseFieldType[
      ExtendedDatabaseFieldTypeMapping[
        str.toUpperCase() as keyof typeof ExtendedDatabaseFieldTypeMapping
      ]
    ];
  }

  return DatabaseFieldType[str.toUpperCase() as keyof typeof DatabaseFieldType];
};

export const stringToDatabaseLayoutType = (
  str: string
): DatabaseLayoutType | undefined => {
  return DatabaseLayoutType[str.toUpperCase() as keyof typeof DatabaseLayoutType];
};

export const stringToDatabaseCardWidth = (str: string): DatabaseCardWidth | undefined => {
  return DatabaseCardWidth[str.toUpperCase() as keyof typeof DatabaseCardWidth];
};

export const extractIssueKeyFromUrl = (url: string): string => {
  const trimmedUrl = url.replace(/\/$/, '');
  const segments = trimmedUrl.split('/');
  return segments.length > 0 ? segments[segments.length - 1] : '';
};

export const getCloudId = (url: string): string | undefined => {
  try {
    const urlOrigin = new URL(url);
    const jiraSite = SiteService.getInstance().getJiraSiteForOrigin(urlOrigin.origin);
    return jiraSite?.cloudId;
  } catch (e) {
    return undefined;
  }
};

export function logValidationErrors(errors: ProcessingError[]): void {
  for (const error of errors) {
    if (error.severity === 'warning') {
      logWarning(new Error(error.message));
    } else {
      logError(new Error(error.message));
    }
  }
}

// TODO: we can always split with pipe delimiter after the prompt changes are in.
export function splitMultiValue(value: string): string[] {
  const delimiter = value.includes('|') ? '|' : ',';
  return value.split(delimiter).map((v) => v.trim());
}
